module.exports = __webpack_public_path__ + "static/img/2.d3f3543.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/zh/2.png
// module id = uH96
// module chunks = 0